import notify from 'devextreme/ui/notify'

import store from '../store'

import router from '../router'

function showError(err) {

    const type = 'error'
    const displayTime = process.env.VUE_APP_BASE_MESSAGE_NOTIFY_SHOWTIME

    if (err.response) {
        // リクエストを出し済み、レスポンスのステータスコードは2xx範囲外
        console.log(err.response)

        if (err.response.status.toString().substr(0, 1) == "4") {

            switch (err.response.status) {

                case 401:
                    // 401 認証不正
                    notify({
                        message: process.env.VUE_APP_BASE_MESSAGE_401_ERROR,
                        shading: true
                    }, type, displayTime)

                    if (err.config.url.indexOf("login") == -1) {
                        store.commit({
                            type: 'logout',
                        })

                        router.push({
                            path: "/login-form",
                            query: {
                                redirect: router.path
                            }
                        });
                    }
                    break;
                case 403:
                    // 403 サーバアクセス禁止
                    notify({
                        message: process.env.VUE_APP_BASE_MESSAGE_403_ERROR,
                        shading: true
                    }, type, displayTime)
                    break;
                case 404:
                    // 404 ページが存在しない
                    notify({
                        message: process.env.VUE_APP_BASE_MESSAGE_404_ERROR,
                        shading: true
                    }, type, displayTime)
                    break;
                case 409:
                    // 409 リソースの競合が発生
                    notify({
                        message: err.response.data.errorMessage,
                        shading: true
                    }, type, displayTime)
                    break;
                default:
                    // 他の4xxは統一にアクセス不正にする
                    notify({
                        message: process.env.VUE_APP_BASE_MESSAGE_4_ERROR,
                        shading: true
                    }, type, displayTime)

                    break;
            }
        }

        if (err.response.status.toString().substr(0, 1) == "5") {
            notify({
                message: err.response.data.errorMessage,
                shading: true
            }, type, displayTime)
        }
    } else if (err.request) {
        //リクエスト失敗
        console.log(err.response);

        notify({
            message: process.env.VUE_APP_BASE_MESSAGE_REQUEST_ERROR,
            shading: true
        }, type, displayTime)
    } else {
        //リクエスト未知エラー
        console.log(err)

        notify({
            message: process.env.VUE_APP_BASE_MESSAGE_UNKNOWN_ERROR,
            shading: true
        }, type, displayTime)
    }

    console.log(err.config);
}

export const errorCommon = {
    showError
};